import i from "tailwindcss/plugin";
import o from "../../tailwind.config.js";
const m = i(function() {
}, o);
export {
  m as NormaUiTailwindPlugin
};
